import {Timeline as MantineTimeline, TimelineProps as MantineTimelineProps} from "@mantine/core";
import {TimelineItem} from "./TimelineItem";

export type TimelineProps = MantineTimelineProps

export const Timeline = (props: TimelineProps) => {
    const {...rest} = props;
    return <MantineTimeline {...rest} />;
};

Timeline.Item = TimelineItem;
